module.exports = __webpack_public_path__ + "static/media/866-536x354.ac271de8.jpg";